let chart = null;


let chartLibsPromise = null;
function loadChartLibs() {
  if (!window.CHART_LIBS || !window.CHART_LIBS.length) {
    return Promise.resolve();
  }
  if (!chartLibsPromise) {
    chartLibsPromise = (async () => {
      for (const src of window.CHART_LIBS) {
        await new Promise((resolve, reject) => {
          const s = document.createElement("script");
          s.src = src;
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
      }
    })();
  }
  return chartLibsPromise;
}

const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    } else {
      reject(new Error("Geolocation is not supported by this browser."));
    }
  });
};

const getDataFromAPI = async (lat, lng) => {
  try {
    const response = await fetch(
      `https://api.open-meteo.com/v1/elevation?latitude=${lat}&longitude=${lng}`
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return {
      value: data.elevation,
      time: new Date(),
    };
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

const initChart = () => {
  const ctx = document.getElementById("elevationGraph").getContext("2d");

  if (chart) {
    chart.destroy();
  }

  const maxTicksLimit = window.innerWidth < 768 ? 3 : 6;

  chart = new Chart(ctx, {
    type: "line",
    data: {
      datasets: [
        {
          label: "Elevation Data",
          data: [],
          borderColor: "#007f61",
          fill: false,
          pointRadius: 0,
          borderWidth: 2,
          tension: 0.4,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: "time",
          time: {
            unit: "second",
            tooltipFormat: "HH:mm:ss",
            displayFormats: {
              second: "HH:mm:ss",
            },
          },
          title: {
            display: true,
            text: "Time",
          },
          ticks: {
            maxTicksLimit: maxTicksLimit,
            autoSkip: true,
            maxRotation: 0,
            minRotation: 0,
          },
          grid: {
            display: true,
            color: "rgba(200, 200, 200, 0.3)",
            lineWidth: 1,
          },
        },
        y: {
          title: {
            display: true,
            text: "Elevation (m)",
          },
          ticks: {
            beginAtZero: false,
          },
          grid: {
            display: true,
            color: "rgba(200, 200, 200, 0.3)",
            lineWidth: 1,
          },
        },
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: function (context) {
              const label = context.dataset.label || "";
              const value = context.raw.y || "";
              return `${label}: ${value} m`;
            },
          },
        },
        legend: {
          display: false,
        },
      },
      elements: {
        point: {
          radius: 0,
        },
        line: {
          tension: 0.4,
        },
      },
    },
  });
};

const updateChart = async (lat, lng) => {

  try {

    const data = await getDataFromAPI(lat, lng);

    if (data) {

      const currentTime = new Date();

      chart.data.datasets[0].data.push({
        x: currentTime,
        y: data.value,
      });

      chart.update();

    }

  } catch (error) {

    console.error("Error fetching data:", error);

  }

};

async function startDrawchart() {

  let userLocation;


  const libsPromise = loadChartLibs();

  try {

    const position = await getUserLocation();

    userLocation = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    };

    window.currentlat = userLocation.latitude;
    window.currentlng = userLocation.longitude;

  } catch (error) {

    console.error("Error getting user location:", error);

    return;
  }


  await libsPromise;
  initChart();

  await updateChart(userLocation.latitude, userLocation.longitude);


  setInterval(

    () => updateChart(window.currentlat, window.currentlng),

    10000
  );
}

window.startDrawchart = startDrawchart;